__turbopack_context__.v({
  "note": "TaxNote-module-scss-module__qQN1UG__note",
});
